import React from "react";
import { Link } from "react-router-dom";
import Logo from "../Logo";

const Sidebar = () => {
  return (
    <div>
      <div className="header-mobile">
        <a className="header-toggle" href="#home">
          <i className="fas fa-bars"></i>{" "}
        </a>
        <a href="/">
          <h2>prakash karena</h2>
        </a>
      </div>
      {/* Left Block  */}
      <nav className="header-main" data-simplebar="">
        {/* Logo  */}
        <Logo />
        <ul>
          <li data-tooltip="home" data-position="top">
            <Link to="/" className="icon-h fas fa-house-damage" />
          </li>
          <li data-tooltip="about" data-position="top">
            <Link to="/about" className="icon-a fas fa-user-tie" />
          </li>
          <li data-tooltip="resume" data-position="top">
            <Link to="/resume" className="icon-r fas fa-address-book" />
          </li>
          <li data-tooltip="portfolio" data-position="top">
            <Link to="/portfolio" className="icon-p fas fa-briefcase" />
            {/* <a href="/portfolio" className="icon-p fas fa-briefcase">
              {" "}
            </a> */}
          </li>

          <li data-tooltip="blog" data-position="top">
            <a
              target="blank"
              href="https://learnwith-kp.blogspot.com/"
              className="icon-b fas fa-receipt"
            >
              {" "}
            </a>
          </li>

          <li data-tooltip="contact" data-position="bottom">
            <Link to="/contact" className="icon-c fas fa-envelope" />
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
